module.exports = {
    devServer: {
         proxy: 'https://portal.flemingmedicina.com.br/',
    }
}

